<template>
    <div style="width: 100%; height: calc(100vh - 80px - 64px); position: relative">
        <v-row no-gutters style="position: sticky; top: 0; left: 0; height: 48px" class="px-2">
            <v-col :cols="7" class="d-flex flex-row align-center h-100">
                <div style="width: 192px">
                    <CustomToolbarBtn
                        icon="$fa-bars"
                        title="Vos objets"
                        @click="toggleObjectsMenu"
                    />
                </div>
                <v-divider vertical inset />
                <!-- <span class="px-5"></span> -->
                <template v-if="showDesignerMenu">
                    <CustomToolbarDropdown icon="$fa-square" title="Basic">
                        <v-list lines="one">
                            <v-list-item @click="addTextField">
                                <template #append>
                                    <v-icon size="x-small">$fa-plus</v-icon>
                                </template>

                                <v-list-item-title>Texte</v-list-item-title></v-list-item
                            >
                            <v-list-item @click="addTitle">
                                <template #append>
                                    <v-icon size="x-small">$fa-plus</v-icon>
                                </template>

                                <v-list-item-title>Titre</v-list-item-title></v-list-item
                            >
                            <v-list-item>
                                <template #append>
                                    <v-icon size="x-small">$fa-plus</v-icon>
                                </template>

                                <v-list-item-title>Image</v-list-item-title></v-list-item
                            >
                            <v-list-item>
                                <template #append>
                                    <v-icon size="x-small">$fa-plus</v-icon>
                                </template>

                                <v-list-item-title>Trait</v-list-item-title></v-list-item
                            >
                        </v-list>
                    </CustomToolbarDropdown>
                    <CustomToolbarDropdown icon="$fa-table" title="Widgets">
                        <v-list lines="one">
                            <v-list-item>
                                <template #append>
                                    <v-icon size="x-small">$fa-plus</v-icon>
                                </template>

                                <v-list-item-title>Carte</v-list-item-title></v-list-item
                            >
                            <v-list-item @click="addIndicator">
                                <template #append>
                                    <v-icon size="x-small">$fa-plus</v-icon>
                                </template>

                                <v-list-item-title>Indicateur</v-list-item-title></v-list-item
                            >
                            <v-list-item @click="addRatio">
                                <template #append>
                                    <v-icon size="x-small">$fa-plus</v-icon>
                                </template>

                                <v-list-item-title>Ratio</v-list-item-title></v-list-item
                            >
                            <v-list-item @click="addAccountingResults">
                                <template #append>
                                    <v-icon size="x-small">$fa-plus</v-icon>
                                </template>
                                <v-list-item-title> Tableaux comptables </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </CustomToolbarDropdown>
                    <CustomToolbarDropdown icon="$fa-table-cells-large" title="Conteneurs">
                        <v-list lines="one">
                            <v-list-item @click="addBox" density="compact">
                                <template #append>
                                    <v-icon size="x-small">$fa-plus</v-icon>
                                </template>

                                <v-list-item-title>Boite simple</v-list-item-title></v-list-item
                            >
                            <v-list-item @click="addSimpleContainer" density="compact">
                                <template #append>
                                    <v-icon size="x-small">$fa-square</v-icon>
                                </template>

                                <v-list-item-title>Conteneur simple</v-list-item-title></v-list-item
                            >
                            <v-list-item @click="addGridBox" density="compact">
                                <template #append>
                                    <v-icon size="x-small" icon="$fa-border-all" />
                                </template>

                                <v-list-item-title>Grille</v-list-item-title></v-list-item
                            >
                            <v-list-item density="compact">
                                <template #append>
                                    <v-icon size="x-small">$fa-plus</v-icon>
                                </template>

                                <v-list-item-title>Carte</v-list-item-title></v-list-item
                            >
                        </v-list>
                    </CustomToolbarDropdown>
                </template>
            </v-col>
            <!-- <v-col cols="2" class="d-flex flex-row justify-center align-center">
                <v-btn
                    small rounded color="primary" elevation="0" dark
                    @click="visibleEditionOptions = 'editor'"
                    class="mr-1"
                    :disabled="visibleEditionOptions === 'editor'"
                >
                    Editeur
                </v-btn>
                <v-divider vertical inset></v-divider>
                <v-btn
                    small rounded color="primary" elevation="0" dark
                    @click="visibleEditionOptions = 'theme'"
                    class="ml-1"
                    :disabled="visibleEditionOptions === 'theme'"
                >
                    Thème
                </v-btn>
            </v-col> -->
            <v-spacer />
            <v-col cols="2" class="py-3 d-flex justify-end h-100">
                <CustomToolbarBtn
                    v-if="selectedBox && showDesignerMenu"
                    icon="$fa-gear"
                    title="Customisation"
                    class="ml-1 px-1"
                    @click="openCustomizationPane"
                />
                <CustomToolbarBtn
                    v-else-if="selectedBox && showReportMenu"
                    icon="$fa-gear"
                    title="Contenu"
                    class="ml-1 px-1"
                    @click="openCustomizationPane"
                />
                <!-- <v-btn
                    v-if="selectedBox"
                    class="ml-1 px-1"
                    size="small"
                    @click="openCustomizationPane"
                >
                    <v-icon size="small" class="mr-2">$fa-gear </v-icon>
                    <span v-if="showDesignerMenu">Customisation</span>
                    <span v-else-if="showReportMenu">Contenu</span>
                </v-btn> -->
                <CustomToolbarBtn
                    v-if="showDesignerMenu"
                    icon="$fa-gear"
                    title="Thèmes"
                    class="ml-1 px-1"
                    @click="openThemeEditor"
                />
                <!-- <v-btn
                    v-if="showDesignerMenu"
                    elevation="0"
                    class="ml-1 px-1"
                    size="small"
                    @click="openThemeEditor"
                >
                    <v-icon size="small" class="mr-2">$fa-gear </v-icon>
                    <span>Thèmes</span>
                </v-btn> -->
            </v-col>
            <v-col cols="3" class="py-3 d-flex justify-end h-100">
                <v-btn-toggle v-model="togglePreview" mandatory="force" class="h-100">
                    <v-btn density="compact" size="small" rounded="0" variant="outlined">
                        <v-icon size="small" class="mr-2">$fa-object-ungroup</v-icon>
                        Edition
                    </v-btn>
                    <v-btn density="compact" size="small" rounded="0" variant="outlined">
                        <v-icon size="small" class="mr-2">$fa-tachometer-alt</v-icon>
                        Rapport
                    </v-btn>
                    <v-btn density="compact" size="small" rounded="0" variant="outlined">
                        <v-icon size="small" class="mr-2">$oss-eye</v-icon>
                        Preview
                    </v-btn>
                </v-btn-toggle>
            </v-col>
            <!-- <v-col cols="2" class="py-0">
                <v-select v-model="selectedView"
                    :items="viewOptions"
                    dense
                    x-small
                    outlined
                    hide-details="auto"
                    :disabled="togglePreview"
                    height="32px"
                    label="Vue">
                </v-select>
            </v-col> -->
        </v-row>
        <v-row no-gutters style="position: relative">
            <div
                v-if="isObjectsMenuShown"
                style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    overflow-y: auto;
                    height: 100%;
                    max-height: calc(100vh - 64px - 52px);
                    padding: 16px;
                    width: 200px;
                    background: whitesmoke;
                    z-index: 1;
                    border-right: 1px solid rgba(0, 0, 0, 0.2);
                "
                class="px-0 py-2 scrollbar-hidden"
            >
                <v-card class="ma-0" elevation="0" rounded="0" style="background: whitesmoke">
                    <!-- <v-card-title>Vos objets</v-card-title> -->
                    <v-row v-if="layout" no-gutters>
                        <v-list
                            v-if="layout.allObjects.length"
                            style="width: 100%; background: whitesmoke"
                        >
                            <draggable
                                :list="layout.allObjects"
                                @change="onDragChange"
                                @end="onDragEnd"
                                @start="onDragStart"
                                :group="{ name: 'a', pull: 'clone', put: false }"
                            >
                                <!-- <template v-for="object of layout.allObjects" :key="object.box.id"> -->
                                <template #item="{ element: object }">
                                    <v-list-item
                                        density="compact"
                                        class="pl-2 pr-0"
                                        :key="object.box.id"
                                        :style="{
                                            background:
                                                selectedBox === object.box
                                                    ? 'rgba(249, 177, 40, 0.3)'
                                                    : null,
                                            cursor: 'pointer',
                                        }"
                                        @click.stop="selectBox(object.box)"
                                    >
                                        <span :class="`px-${object.depth}`" />
                                        <template #prepend class="mx-0">
                                            <v-icon size="small">$fa-square</v-icon>
                                        </template>

                                        <template #append class="object-options">
                                            <v-icon
                                                v-if="object.box && !object.box.visible"
                                                size="x-small"
                                                >$oss-eye-slash</v-icon
                                            >
                                            <BoxPopupMenu
                                                :box="object.box"
                                                :hideOptions="hiddenObjectsMenuOptions"
                                                @duplicate-box="duplicateBox"
                                                @delete-box="removeBox"
                                                @edit-box="editBox"
                                                @move-box-to-front="moveBoxToFront"
                                                @move-box-to-back="moveBoxToBack"
                                                @move-box-forward="moveBoxForward"
                                                @move-box-backward="moveBoxBackward"
                                                @toggle-box-visibility="toggleBoxVisibility"
                                            />
                                            <!-- <v-btn smal icon>
                                                <v-icon size="small">fa-ellipsis-v</v-icon>
                                            </v-btn> -->
                                        </template>
                                        <v-tooltip location="bottom">
                                            <template v-slot:activator="{ props }">
                                                <v-list-item-title v-bind="props">{{
                                                    object.box.name
                                                }}</v-list-item-title>
                                            </template>
                                            <span class="text-caption">{{
                                                object.box.name
                                            }}</span> </v-tooltip
                                        ><v-list-item-subtitle>{{
                                            object.box.friendlyTypename
                                        }}</v-list-item-subtitle></v-list-item
                                    >
                                </template>
                            </draggable>
                        </v-list>
                        <!-- <template v-for="object of layout.allObjects">
                            <v-col v-ripple cols="12" class="d-flex flex-row py-2 pl-2 pr-0" :style="{background: selectedBox === object.box ? 'rgba(249, 177, 40, 0.3)': null, cursor: 'pointer'}" :key="object.box.id" @click.stop="selectBox(object.box)">
                                <v-row no-gutters>
                                    <v-col cols="3">
                                        <span :class="`px-${object.depth}`"></span>
                                        <v-btn small icon class="mr-2">
                                            <v-icon size="small">far fa-square</v-icon>
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="7" class="d-flex flex-column" style="overflow-x: hidden;">
                                        <div class="d-flex flex-row">
                                            <span class="text-subtitle-1" style="text-overflow: ellipsis;">{{ object.box.name }}</span>
                                        </div>
                                        <div class="text-body-1 text--secondary">{{ object.box.friendlyTypename }}</div>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn small icon>
                                            <v-icon size="small">fa-ellipsis-v</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </template> -->
                    </v-row>
                </v-card>
            </div>
            <v-col :cols="!visibleEditionOptions ? 12 : 9">
                <div @drop="onDrop" @dragover.prevent v-if="togglePreview !== 1">
                    <!-- <draggable :list="layoutChildren" @change="onDrop" :group="{name: 'a', put: false}"> -->
                    <DesignerLayout
                        @layout="setLayout($event)"
                        @selected-box="handleSelectedBox($event)"
                        @duplicate-box="duplicateBox"
                        @delete-box="removeBox"
                        @edit-box="editBox"
                        @move-box-to-front="moveBoxToFront"
                        @move-box-to-back="moveBoxToBack"
                        @move-box-forward="moveBoxForward"
                        @move-box-backward="moveBoxBackward"
                        @toggle-box-visibility="toggleBoxVisibility"
                        :initialLayout="layout"
                        :editedBox="editedBox"
                        :viewType="viewType"
                        :view="selectedView"
                        :generalTheme="selectedGeneralTheme"
                        ref="designerLayout"
                    />
                    <!-- </draggable> -->
                </div>
                <div v-else @drop="onDropOnReport" @dragover.prevent>
                    <ReportPage
                        :themeSettings="themeSettings"
                        :reportType="selectedReportType"
                        :initialReport="workingReport"
                        @report="onReportEmitted"
                        @selected-box="handleSelectedBox($event)"
                        @duplicate-box="duplicateBox"
                        @delete-box="removeBox"
                        @edit-box="editBox"
                        @move-box-to-front="moveBoxToFront"
                        @move-box-to-back="moveBoxToBack"
                        @move-box-forward="moveBoxForward"
                        @move-box-backward="moveBoxBackward"
                        @toggle-box-visibility="toggleBoxVisibility"
                    />
                </div>
            </v-col>

            <v-col
                cols="3"
                v-if="showDesignerMenu && visibleEditionOptions"
                style="background: white"
            >
                <v-card rounded="0" flat>
                    <v-card-title class="d-flex flex-row">
                        Options d'édition
                        <v-spacer />
                        <div>
                            <v-btn-icon
                                size="small"
                                @click="closeCustomizationPane"
                                icon="$fa-times"
                            >
                            </v-btn-icon>
                        </div>
                    </v-card-title>
                </v-card>
                <v-tabs fixed-tabs v-model="editorTab">
                    <v-tab v-if="!themeEditorOnly" :value="0" href="#properties-tab"
                        >Propriétés</v-tab
                    >
                    <v-tab v-else :value="1" href="#themes-tab">Thème</v-tab>
                </v-tabs>
                <v-tabs-window v-model="editorTab">
                    <v-window-item v-if="!themeEditorOnly" value="properties-tab">
                        <v-card rounded="0">
                            <!-- <v-card-title>Editeur</v-card-title>
                            <v-row no-gutters class="px-2 py-3 align-start scrollbar-hidden" style="max-height: calc(60vh - 90px - 23px); overflow-y: auto;">
                                <v-col cols="12" class="pb-3 d-flex justify-start align-start">
                                    <h4>Editeur</h4>
                                </v-col>
                            </v-row> -->
                            <v-row
                                v-if="selectedBox"
                                no-gutters
                                class="px-2 py-3 scrollbar-hidden d-flex align-start"
                                style="
                                    max-height: calc(100vh - 56px - 176px);
                                    overflow-y: auto;
                                    position: relative;
                                    z-index: 2;
                                "
                            >
                                <v-col cols="12" class="d-flex flex-row pb-3 align-start">
                                    <!-- <h4 v-if="selectedBox.properties">Propriétés</h4> -->
                                    <v-row no-gutters class="px-1">
                                        <v-col>
                                            <v-text-field-filled
                                                v-model="selectedBox.name"
                                                label="Nom du composant"
                                                hide-details
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                        <v-col
                                            cols="3"
                                            class="mb-3 d-flex flex-row align-self-start"
                                        >
                                            <v-btn-icon
                                                icon="$fa-clone"
                                                @click="duplicateSelectedBox"
                                                size="small"
                                            >
                                                <v-icon />
                                                <v-tooltip activator="parent">Supprimer</v-tooltip>
                                            </v-btn-icon>
                                            <v-btn-icon
                                                icon="$oss-trash"
                                                size="small"
                                                @click="removeSelectedBox"
                                            >
                                                <v-icon color="error" />
                                                <v-tooltip activator="parent">Supprimer</v-tooltip>
                                            </v-btn-icon>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" class="d-flex flex-row align-self-start">
                                    <PropertiesEditor
                                        v-if="selectedBox.properties"
                                        :properties="selectedBox.properties"
                                        :propertiesOptions="selectedBox.propertiesOptions"
                                    />
                                </v-col>
                                <v-col cols="12"><v-divider /></v-col>
                                <v-col cols="12" class="d-flex align-start">
                                    <v-expansion-panels accordion flat class="align-self-start">
                                        <v-expansion-panel>
                                            <v-expansion-panel-title
                                                disable-icon-rotate
                                                class="px-2"
                                            >
                                                <span>Plus d'options...</span>
                                                <template v-slot:actions>
                                                    <v-icon size="x-small" color="secondary">
                                                        $fa-plus
                                                    </v-icon>
                                                </template>
                                            </v-expansion-panel-title>
                                            <v-expansion-panel-text class="wrapper-px-2">
                                                <v-col
                                                    v-if="selectedBox.style"
                                                    cols="12"
                                                    class="py-3 px-0 d-flex flex-row"
                                                >
                                                    <h4>Style</h4>
                                                    <v-spacer />
                                                    <v-btn
                                                        size="small"
                                                        @click="copyBoxStyleFromSelectedTheme"
                                                    >
                                                        <span>Style du thèmess</span>
                                                        <template #prepend>
                                                            <v-icon color="white">$fa-copy</v-icon>
                                                        </template>
                                                    </v-btn>
                                                </v-col>
                                                <v-col cols="12" class="px-0">
                                                    <PropertiesEditor
                                                        v-if="selectedBox.style"
                                                        :properties="selectedBox.style"
                                                        :propertiesOptions="
                                                            selectedBox.styleOptions
                                                        "
                                                    />
                                                </v-col>
                                                <v-col
                                                    v-if="
                                                        selectedBox.style &&
                                                        selectedBox.style.boxTitle &&
                                                        selectedBox.properties.title
                                                    "
                                                    cols="12"
                                                    class="py-2 px-0 d-flex flex-row"
                                                >
                                                    <h4>Style du titre de la boite</h4>
                                                    <v-spacer />
                                                    <v-btn
                                                        size="small"
                                                        elevation="0"
                                                        @click="copyBoxTitleStyleFromSelectedTheme"
                                                    >
                                                        <template #prepend>
                                                            <v-icon color="white">$fa-copy</v-icon>
                                                        </template>
                                                        <span>Style du thèmes</span>
                                                    </v-btn>
                                                </v-col>

                                                <v-col cols="12" class="px-0">
                                                    <PropertiesEditor
                                                        v-if="
                                                            selectedBox.style &&
                                                            selectedBox.style.boxTitle &&
                                                            selectedBox.properties.title
                                                        "
                                                        :properties="selectedBox.style.boxTitle"
                                                        :propertiesOptions="
                                                            selectedBox.styleOptions.boxTitle
                                                        "
                                                    />
                                                </v-col>
                                            </v-expansion-panel-text>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-window-item>
                    <v-window-item value="themes-tab">
                        <DesignerTheme
                            :tablesThemeSettings="tablesThemeSettings"
                            :chartsThemeSettings="chartsThemeSettings"
                            :generalThemeSettings="generalThemeSettings"
                        />
                    </v-window-item>
                </v-tabs-window>
                <!-- <h4 class ></h4> -->
            </v-col>
            <v-col
                cols="3"
                v-else-if="showReportMenu && visibleEditionOptions"
                style="background: white"
            >
                <v-card rounded="0" flat>
                    <v-card-title class="d-flex flex-row">
                        Options du contenu
                        <v-spacer />
                        <div>
                            <v-btn-icon
                                icon="$fa-times"
                                size="small"
                                @click="closeCustomizationPane"
                            >
                            </v-btn-icon>
                        </div>
                    </v-card-title>
                    <v-row
                        v-if="selectedBox"
                        no-gutters
                        class="px-2 py-3 scrollbar-hidden d-flex align-start"
                        style="
                            max-height: calc(100vh - 56px - 176px);
                            overflow-y: auto;
                            position: relative;
                            z-index: 2;
                        "
                    >
                        <v-col cols="12" class="d-flex flex-row pb-3 align-start">
                            <span class="text-subtitle-1">{{ selectedBox.name }}</span>
                        </v-col>
                        <v-col cols="12" class="d-flex flex-row align-self-start">
                            <PropertiesEditor
                                v-if="selectedBox.reportProperties"
                                :properties="selectedBox.reportProperties"
                                :propertiesOptions="selectedBox.reportPropertiesOptions"
                            />
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script lang="ts">
import DesignerLayout from "./DesignerLayout.vue";
import { Component, Vue, toNative, Watch } from "vue-facing-decorator";
import {
    AccountingResultsBoxModel,
    Box,
    ComponentBoxModel,
    GridContainer,
    IndicatorComponentBoxModel,
    Layout,
    RatioComponentBoxModel,
    SimpleContainer,
    TextFieldBox,
    TitleBox,
    ReportType,
} from "./models";
import PropertiesEditor from "./PropertiesEditor.vue";
import DesignerTheme from "./DesignerTheme.vue";
import CustomToolbarDropdown from "./CustomToolbarDropdown.vue";
import DesignerDataService from "./designerDataService";
import * as _ from "lodash";
import { checkAccessRights } from "@/services/accessRightServices";
import { User } from "../../store/store";
import { OperatingAccountDataInterface } from "./models";
import CustomToolbarBtn from "./CustomToolbarBtn.vue";
import draggable from "vuedraggable";
import BoxPopupMenu from "./BoxPopupMenu.vue";
import ReportPage from "./ReportPage.vue";
import { Report } from "./models";
import DesignerService from "./designer.service";

@Component({
    components: {
        DesignerLayout,
        PropertiesEditor,
        DesignerTheme,
        CustomToolbarDropdown,
        CustomToolbarBtn,
        draggable,
        BoxPopupMenu,
        ReportPage,
    },
    emits: ["selected-box"],
})
export class DesignerPage extends Vue {
    title = "Designer";
    layout: Layout = null;
    selectedBox: Box = null;

    movementStep = 10; // Boxes will move by steps of the set number

    togglePreview: number = 0;

    visibleEditionOptions: boolean = false;

    viewOptions = [
        { value: "dashboard", text: "Dashboard" },
        { value: "page", text: "Page" },
    ];

    selectedView = "";

    editorTab: "properties-tab" | "themes-tab" = null;

    themeEditorOnly = false;

    dataService: DesignerDataService = null;
    operatingAccountsData: OperatingAccountDataInterface[] = [];

    isObjectsMenuShown: boolean = false;

    draggedObject: { depth: number; box: Box } = null;
    dragMoveStart: { screenX; screenY } = { screenX: 0, screenY: 0 };

    selectedReportType: ReportType = ReportType.DASHBOARD; // TODO: Implement report type selection

    workingReport: Report = null; // Working report on ReportPage

    hiddenObjectsMenuOptions = ["clone", "delete"];

    get viewType(): "REPORT" | "PREFIEW" | "EDTION" {
        switch (this.togglePreview) {
            case 1:
                return "REPORT";
            case 2:
                return "PREFIEW";
            case 0:
            default:
                return "EDTION";
        }
    }

    get editedBox() {
        return this.selectedBox;
    }

    get company() {
        return this.$store.state.selected_company;
    }

    get accountingPeriodId() {
        console.log("this.$store.state", this.$store.state);
        return this.$store.state.accountingPeriod?.selectedAccountingPeriod?.id;
    }

    get selectedAccountingPeriod() {
        return this.$store.state.accountingPeriod?.selectedAccountingPeriod;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "accounting", "dashboard");
        return authorized;
    }

    get layoutChildren() {
        return this.layout?.children ?? [];
    }

    get showDesignerMenu() {
        return this.togglePreview === 0;
    }

    get showReportMenu() {
        return this.togglePreview === 1;
    }

    async beforeMount() {
        this.selectedView = "dashboard";
        this.initListeners();
        console.log("this.company?.id", this.company);
        console.log("selectedAccountingPeriod", this.selectedAccountingPeriod);
        this.dataService = new DesignerDataService(this.company);
        if (this.isAuthorized) {
            this.operatingAccountsData =
                await this.dataService.fetchOperatingAccountJsons("OPERATING_ACCOUNT");
            console.log("operatingAccountJsons", this.operatingAccountsData);
        }
        // const tablesData = await this.dataService.fetchTablesData({
        //     className: "OperatingAccountCustom",
        //     budgetId: "", // TODO need to fetch budgetId and provide a  way to select one
        //     periods: [
        //         {
        //             "start": "2024-01-01",
        //             "end": "2024-12-31",
        //             "monthly": true, //this.selectedBox?.properties?.dense === false,
        //             "accountingPeriodId": "clpweci910002h5m494c0tccq"
        //         },
        //         {
        //             "start": "2023-01-01",
        //             "end": "2023-12-31",
        //             "accountingPeriodId": "clbyowol44080g9smsajj89uh",
        //             "type": "nMoinsUn"
        //         }
        //     ],
        //     tags: [],
        //     operatingAccountId: "clesc5ora0022gism9uwft9lr",
        //     accountingPeriodId: this.accountingPeriodId
        // })

        // console.log("tablesData", tablesData)
    }

    beforeDestroy() {
        this.removeListeners();
    }

    @Watch("togglePreview")
    onTogglePreview(newVal, oldVal) {
        if (this.selectedBox) {
            // unselect box
            this.selectedBox.isSelected = false;
        }
        this.selectedBox = null;
    }

    @Watch("selectedBox")
    onBoxSelected(newVal) {
        if (!this.selectedBox) {
            this.closeCustomizationPane();
        }
    }

    /**
     * New report emitted from ReportPage
     * @param report
     */
    onReportEmitted(report: Report): void {
        this.workingReport = report;
    }

    handleSelectedBox(box) {
        // debugger
        this.selectedBox = box;
        console.log("selected-box 2", box, this.selectedBox);
    }

    initListeners() {
        // this.$el.addEventListener("click", this.removeSelectedBox)
        document.addEventListener("keyup", this.onKeyup);
    }

    removeListeners() {
        // this.$el.removeEventListener("click", this.removeSelectedBox)
        document.removeEventListener("keyup", this.onKeyup);
    }

    onKeyup(evt: KeyboardEvent) {
        if (evt.key === "Delete") {
            this.removeSelectedBox();
        }
    }

    toggleObjectsMenu() {
        this.isObjectsMenuShown = !this.isObjectsMenuShown;
    }

    onDragChange(evt) {
        // TODO: prevent any possible list sorting
        // debugger
        console.log("onDragChange", evt);
    }

    onDrop(evt: DragEvent) {
        // debugger
        console.log("onDrop", evt);

        if (this.draggedObject?.box) {
            const cloned = this.draggedObject.box.clone();
            const svg = (evt.target as any).closest("svg#grid") as SVGSVGElement;
            console.log("svg", svg);
            if (svg) {
                const svgCoords = DesignerService.getSVGCoordinates(svg, evt.clientX, evt.clientY);
                const { x, y } = this.roundCoordinates(svgCoords.x, svgCoords.y);
                cloned.x = x;
                cloned.y = y;
            } else {
                // cloned.x = evt.screenX - this.dragMoveStart.screenX
                // cloned.y = evt.screenY - this.dragMoveStart.screenY
                cloned.x = evt.clientX;
                cloned.y = evt.clientY;
            }

            cloned.parentContainer = this.layout;
            cloned.layout = this.layout;
            this.layout.addBox(cloned);
        }
    }

    onDropOnReport(evt: DragEvent) {
        // debugger
        console.log("onDropOnReport", evt);

        if (this.draggedObject?.box) {
            const cloned = this.draggedObject.box.clone();
            const svg = (evt.target as any).closest("svg.report-element") as SVGSVGElement;
            console.log("svg report", svg);
            if (svg) {
                const svgCoords = DesignerService.getSVGCoordinates(svg, evt.clientX, evt.clientY);
                const { x, y } = this.roundCoordinates(svgCoords.x, svgCoords.y);
                console.log("{x, y}", { x, y }, { clientX: evt.clientX, clientY: evt.clientY });
                cloned.x = x;
                cloned.y = y;
                const reportElement = this.workingReport.elementById(svg.id);
                cloned.layout = reportElement;
                reportElement.addBox(cloned);
                console.log("reportElement", reportElement);
            }
        }
    }

    onDragEnd(evt) {
        // debugger
        console.log("onDragEnd", evt);
    }

    onDragStart(evt) {
        // debugger
        const el = evt.target as Element;
        // const rect = el.getBoundingClientRect()
        // console.log("rect", rect, "evt.originalEvent.screenX", evt.originalEvent.screenX, "evt.originalEvent.screenY", evt.originalEvent.screenY)
        // const xOffset = rect.x
        this.draggedObject = this.layout.allObjects[evt.oldIndex];
        this.dragMoveStart.screenX = evt.originalEvent.screenX;
        this.dragMoveStart.screenY = evt.originalEvent.screenY + 64;
        console.log(
            "onDragStart",
            evt,
            "this.draggedObject",
            this.draggedObject,
            "this.dragMoveStart",
            this.dragMoveStart,
        );
    }

    roundCoordinates(x: number, y: number): { x: number; y: number } {
        return {
            x: Math.round(x / this.movementStep) * this.movementStep,
            y: Math.round(y / this.movementStep) * this.movementStep,
        };
    }

    cardAmountTestProps = {
        accountingKey: "GMmaP08MdztHyvBH",
        showBtnDetails: true,
        id: "TurnoverDashboard",
        companyId: "ck93umltabtuf0730wifcojfb",
        periods: [
            {
                start: "2024-01-01",
                end: "2024-12-31",
            },
        ],
        legend: false,
    };

    cardRatioTestProps = {
        // accountingKey: 'GMmaP08MdztHyvBH',
        // showBtnDetails: true,
        // id: "TurnoverDashboard",
        companyId: "ck93umltabtuf0730wifcojfb",
        periods: [
            [
                {
                    start: "2024-01-01",
                    end: "2024-12-31",
                },
            ],
        ],
        settings: {
            key1: "dg6e8ToeyZIYfeqM",
            key2: "K5M7dlWgTNheYB5E_70",
            options: null,
        },
        idCard: "cm1ov3iv100019osuwerq4xay",
        legend: false,
    };

    testAccountResultsProps = {
        embedded: true,

        operatingAccountId: "clesc5ora0022gism9uwft9lr",
        options: {
            title: "Compte de résultat",
            className: "OperatingAccountCustom",
            type: "INCOME_STATEMENT",
            accountingPeriodRequired: false,
        },
        budgetId: "",
        myKey: 1,
        currentKey: 1,
        withSelector: false,
        periods: [
            {
                start: "2024-01-01",
                end: "2024-12-31",
                monthly: true, //this.selectedBox?.properties?.dense === false,
                accountingPeriodId: "clpweci910002h5m494c0tccq",
            },
            {
                start: "2023-01-01",
                end: "2023-12-31",
                accountingPeriodId: "clbyowol44080g9smsajj89uh",
                type: "nMoinsUn",
            },
        ],
        tags: [],
        displayMonthlyData: true, //this.selectedBox?.properties?.dense === false,
        round: true,
    };

    performAddComponent(box: Box) {
        if (this.showDesignerMenu) {
            if (box) {
                box.themeSettings = this.themeSettings;
                box.parentContainer = this.layout;
                box.name = box.friendlyTypename + " " + (this.layout.children.length + 1);
                console.log(
                    "performAddComponent",
                    box.themeSettings === this.themeSettings,
                    Object.is(box.themeSettings, this.themeSettings),
                );
                this.layout.addBox(box);
            }
            this.selectedBox = box;
        }

        console.log("allContainersMap", this.layout.allContainersMap);
    }

    addBox() {
        const newBox = new Box(this.layout, 200, 200, 200, 200, this.themeSettings);
        this.performAddComponent(newBox);
    }

    addTitle() {
        const titleBox = new TitleBox(this.layout, 100, 100, 200, 50, this.themeSettings);
        this.performAddComponent(titleBox);
    }

    addTextField() {
        const textBox = new TextFieldBox(this.layout, 100, 100, 250, 100, this.themeSettings);
        this.performAddComponent(textBox);
    }

    addCardAmount() {
        const newBox = new ComponentBoxModel(this.layout, 250, 100, 400, 300, this.themeSettings);
        // const newBox = new ComponentBoxModel(250, 100, 400, 300, "CardAmount", this.cardAmountTestProps, this.themeSettings)
        this.performAddComponent(newBox);
    }

    addIndicator() {
        const newBox = new IndicatorComponentBoxModel(
            this.layout,
            250,
            100,
            400,
            300,
            "CardAmount",
            this.cardAmountTestProps,
            null,
            this.themeSettings,
        );
        this.performAddComponent(newBox);
    }

    addRatio() {
        const newBox = new RatioComponentBoxModel(
            this.layout,
            250,
            100,
            400,
            300,
            "CardRatio",
            this.cardRatioTestProps,
            null,
            this.themeSettings,
            this.selectedAccountingPeriod,
        );
        this.performAddComponent(newBox);
    }

    async addAccountingResults() {
        const newBox = new AccountingResultsBoxModel(
            this.layout,
            250,
            100,
            600,
            500,
            "AccountingTable",
            this.testAccountResultsProps,
            null,
            this.themeSettings,
            this.selectedAccountingPeriod,
            this.operatingAccountsData,
        );

        this.performAddComponent(newBox);

        // newBox.data = await this.dataService.fetchAccountingResultsTableData({
        //     className: "OperatingAccountCustom",
        //     budgetId: "", // TODO need to fetch budgetId and provide a  way to select one
        //     periods: [
        //         {
        //             "start": "2024-01-01",
        //             "end": "2024-12-31",
        //             "monthly": true, //this.selectedBox?.properties?.dense === false,
        //             "accountingPeriodId": "clpweci910002h5m494c0tccq"
        //         },
        //         {
        //             "start": "2023-01-01",
        //             "end": "2023-12-31",
        //             "accountingPeriodId": "clbyowol44080g9smsajj89uh",
        //             "type": "nMoinsUn"
        //         }
        //     ],
        //     tags: [],
        //     operatingAccountId: "clesc5ora0022gism9uwft9lr",
        //     accountingPeriodId: this.accountingPeriodId
        // })
    }

    addGridBox() {
        const newContainer = new GridContainer(
            this.layout,
            50,
            50,
            400,
            300,
            2,
            2,
            this.themeSettings,
        );

        // const embeddedContainer = new ContainerBox(this.layout, 0, 0, 300, 300, 1, 2, this.themeSettings)
        // embeddedContainer.parentContainer = newContainer
        // newContainer.addBox(embeddedContainer)

        this.performAddComponent(newContainer);
    }

    addSimpleContainer() {
        const newContainer = new SimpleContainer(this.layout, 50, 50, 400, 300, this.themeSettings);

        const newTitle = new TitleBox(this.layout, 60, 60, 150, 50, this.themeSettings);
        newContainer.addBox(newTitle);

        // const embeddedContainer = new ContainerBox(this.layout, 0, 0, 300, 300, 1, 2, this.themeSettings)
        // embeddedContainer.parentContainer = newContainer
        // newContainer.addBox(embeddedContainer)

        this.performAddComponent(newContainer);
    }

    setLayout(layout) {
        this.layout = layout;
    }

    removeBox(box: Box) {
        if (box?.parentContainer) {
            if (box.cell) {
                box.cell.box = null; // Empty cell
            }
            box.parentContainer.removeChildById(box.id);
            if (Object.is(box, this.selectedBox)) {
                this.selectedBox = null;
                this.$emit("selected-box", null);
            }
        }
    }

    removeSelectedBox() {
        this.removeBox(this.selectedBox);
        // if (this.selectedBox && this.layout) {
        //     this.layout.removeChildById(this.selectedBox.id)
        //     this.selectedBox = null
        //     this.$emit("selected-box", null)
        // }
    }

    duplicateBox(box: Box) {
        if (box) {
            const newBox = box.clone(this.layout, true);
            // newBox.x += 10
            // newBox.y += 10
            this.performAddComponent(newBox);
        }
    }

    duplicateSelectedBox() {
        this.duplicateBox(this.selectedBox);
    }

    editBox(box: Box) {
        if (box) {
            this.selectedBox = box;
            this.openCustomizationPane();
        }
    }

    selectBox(box: Box): void {
        this.selectedBox = box;
        this.$emit("selected-box", box);
    }

    // removeSelectedBoxOnDeletePress(evt) {
    //     if
    // }

    get selectedGeneralTheme() {
        return this.generalThemeSettings.themesList[0].values;
    }

    async openCustomizationPane() {
        if (this.selectedBox && (this.showDesignerMenu || this.showReportMenu)) {
            this.visibleEditionOptions = true;
            this.themeEditorOnly = false;
            // setTimeout(() => {
            //     this.editorTab = 1

            // }, 50)
            this.editorTab = "properties-tab";
        }
    }

    openThemeEditor() {
        this.visibleEditionOptions = true;
        this.themeEditorOnly = true;
        this.editorTab = "themes-tab";
    }

    closeCustomizationPane() {
        this.visibleEditionOptions = false;
        this.themeEditorOnly = false;
    }

    moveBoxToFront(box: Box) {
        if (box?.parentContainer) {
            box.parentContainer.moveBoxToFront(box);
        }
    }

    moveBoxToBack(box: Box) {
        if (box?.parentContainer) {
            box.parentContainer.moveBoxToBack(box);
        }
    }

    moveBoxForward(box: Box) {
        if (box?.parentContainer) {
            box.parentContainer.moveBoxForward(box);
        }
    }

    moveBoxBackward(box: Box) {
        if (box?.parentContainer) {
            box.parentContainer.moveBoxBackward(box);
        }
    }

    toggleBoxVisibility(box: Box, visible: boolean) {
        debugger;
        console.log("toggleBoxVisibility", box, visible);
        if (box) {
            box.visible = visible;
        }
    }

    copyBoxStyleFromSelectedTheme() {
        if (this.selectedBox.selectedGeneralTheme?.values.boxStyle && this.selectedBox.style) {
            _.merge(this.selectedBox.style, this.selectedBox.selectedGeneralTheme?.values.boxStyle);
        }
    }

    copyBoxTitleStyleFromSelectedTheme() {
        if (
            this.selectedBox.selectedGeneralTheme?.values.boxTitleStyle &&
            this.selectedBox.style?.boxTitle
        ) {
            _.merge(
                this.selectedBox.style.boxTitle,
                this.selectedBox.selectedGeneralTheme?.values.boxTitleStyle,
            );
        }
    }

    defaultTextColor: string = "#30303FFF";

    // TODO: Keep this at the bottom as it may grow very large and make browsing the code harder
    generalThemeSettings: any = {
        themesList: [
            {
                id: "default",
                displayName: "",
                values: {
                    fontSize: 10,
                    fontFamily: "Arial",
                    // title: {
                    //     background: "#FFFFFFFF",
                    //     color: "#30303FFF",
                    //     bold: false
                    // },
                    boxStyle: {
                        fill: "#FFFFFF00",
                        border: true,
                        stroke: "#333333FF",
                        borderRadius: 0,
                        // boxTitle: {
                        //     fill: "#FFFFFFFF",
                        //     border: true,
                        //     stroke: "#333333FF",
                        //     borderRadius: 0
                        // }
                    },
                    boxTitleStyle: {
                        color: "#30303FFF",
                        fill: "#FFFFFF00",
                        border: true,
                        stroke: "#333333FF",
                        borderRadius: 0,
                        bold: false,
                    },
                    h1: {
                        fontSize: 14,
                        color: this.defaultTextColor,
                        italic: false,
                        bold: true,
                    },
                    h2: {
                        fontSize: 13,
                        color: this.defaultTextColor,
                        italic: false,
                        bold: true,
                    },
                    h3: {
                        fontSize: 12,
                        color: this.defaultTextColor,
                        italic: false,
                        bold: true,
                    },
                },
            },
        ],
    };

    chartsThemeSettings: any = {
        themesList: [
            {
                id: "default",
                displayName: "Par défaut",
                values: {
                    type: "bar",
                    palette: "cool",
                    title: {
                        bold: false,
                    },
                },
            },
            {
                id: "theme2",
                displayName: "Thème 1",
                values: {
                    type: "bar",
                    palette: "warm",
                    title: {
                        bold: false,
                    },
                },
            },
        ],
    };

    tablesThemeSettings: any = {
        themesList: [
            {
                id: "default",
                displayName: "Par défault",
                values: {
                    header: {
                        background: "#C3C3C3FF",
                        color: "#FFFFFFFF",
                        textAlign: "left",
                        border: false,
                        borderColor: "",
                        bold: false,
                        // padding: 2
                    },
                    rows: {
                        background: "#FFFFFFFF",
                        color: "#30303FFF",
                        textAlign: "left",
                        border: false,
                        borderColor: "",
                        bold: false,
                        mode: "simple",
                        secondaryColor: "#E3E3E3FF",
                    },
                    title: {
                        background: "#FFFFFFFF",
                        color: "#30303FFF",
                        bold: false,
                    },
                    subtotals: {
                        background: "#FFFFFFFF",
                        color: "#30303FFF",
                        bold: false,
                    },
                    totals: {
                        background: "#FFFFFFFF",
                        color: "#30303FFF",
                        bold: false,
                    },
                    footer: {
                        background: "",
                        color: "",
                        textAlign: "left",
                        border: false,
                        borderColor: "",
                        bold: false,
                    },
                },
            },
        ],
    };

    themeSettings = {
        general: this.generalThemeSettings,
        charts: this.chartsThemeSettings,
        tables: this.tablesThemeSettings,
    };

    @Watch("themeSettings", { deep: true })
    watch_themeSettings(newVal, oldVal) {
        console.log("themeSettings", newVal, oldVal);
        console.log(
            "themeSettings",
            this.selectedBox?.themeSettings === this.themeSettings,
            Object.is(this.selectedBox?.themeSettings, this.themeSettings),
        );
    }
}

export default toNative(DesignerPage);
</script>
<style lang="css" scoped>
.scrollbar-hidden::-webkit-scrollbar {
    overflow: auto;
    display: none;
    width: 12px;
}

.scrollbar-hidden {
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.v-list-item__icon {
    margin-right: 8px !important;
}

:deep(.v-expansion-panel-content__wrap) {
    padding-left: 8px !important;
    padding-right: 8px !important;
}

:deep(.v-expansion-panel-header) {
    padding-left: 8px !important;
    padding-right: 8px !important;
}

.v-list-item__icon.object-options {
    margin-right: 0 !important;
    margin-left: 0 !important;
}

.wrapper-px-2 > :deep(.v-expansion-panel-text__wrapper) {
    padding-left: 8px !important;
    padding-right: 8px !important;
}
</style>
